import React from 'react'
import Img1 from '../../assets/special/img1.png'
import { PageError, Text } from './style'

export const Page404Text = function () {
  return (
    <PageError>
      <img src={Img1} alt="Los sentimos pero esta página no está disponible." />
      <Text>Los sentimos pero esta página no está disponible.</Text>
    </PageError>
  )
}